import { ADD_REQUEST_BODY_API } from "../Services/API"

//
export const UNAUTHORIZED_HTTP_CODE = 401

//QUERY
export const LOGIN_CHECK = 'LOGIN_CHECK'
export const LOGIN_ATTEMPT = 'LOGIN_ATTEMPT'
export const LOGIN_RESULT = 'LOGIN_RESULT'
export const STUDENT_ACCESS_ATTEMPT = 'STUDENT_ACCESS_ATTEMPT'
export const STUDENT_ACCESS_RESULT = 'STUDENT_ACCESS_RESULT'
export const LOGOUT_ATTEMPT = 'LOGOUT_ATTEMPT'

export const UNAUTHORIZED_CASE = 'UNAUTHORIZED_CASE'

export const CHANGE_PLAYER_KEY = 'CHANGE_PLAYER_KEY'

export function Logout_ACTION(){
    return({
        type: LOGOUT_ATTEMPT
    })
}

export function CheckLogin_ACTION(){
    return({
        type: LOGIN_CHECK
    })
}

export function Login_ACTION(username, password){
    return({
        type: LOGIN_ATTEMPT,
        username:username,
        password:password
    })
}

export function AccessStudent_ACTION(student){
    return({
        type: STUDENT_ACCESS_ATTEMPT,
        student:"student"
    })
}

export function ChangePlayerKey_ACTION(Container){

    return({
        type: CHANGE_PLAYER_KEY,
        Container:Container
    })
}



